import { DevicesAPI, IUpdateDeviceRoomDescription } from "../../services/hcnApi";

export const updateDeviceDescriptionUseCase = async (params: IUpdateDeviceRoomDescription) => {
  await DevicesAPI.updateDeviceRoomDescription(params);
};
